import {reactElementToString} from "./utils";

let i18n = require('gettext.js')();

export function addLocale(locale, code) {
    for (let domain in locale) {
        let messages = locale[domain];
        i18n.setMessages(domain, code, messages, 'nplurals=2; plural=n>1;');
    }
}

export function getCode() {
    return i18n.getLocale();
}

export function t() {
    let args = Array.prototype.map.call(arguments, function(item) { return typeof item == 'object' ? reactElementToString(item) : item });
    return i18n.gettext.apply(i18n, args);
}

export function nt(msgid, msgid_plural, n) {
    return i18n.ngettext(msgid, msgid_plural, n);
}

export function dt(domain, msgid, arg1, arg2, arg3) {
    return i18n.dcnpgettext(domain, '', msgid, undefined, undefined, arg1, arg2, arg3);
}

export function getLangPrefix(lang = false) {
    if(!lang) lang = getLocale();

    if (lang === "fr") return "";
    if (lang === "en") return "/en";

    return "";
}

/**
 * Returns URL cleaned of lang prefixes
 *
 * @param {string} url
 * @return {string}
 */
export function getCleanURL(url) {
    return url.replace(/^\/((en)\/)?(.*)$/, '/$3');
}

export function getLocale() {
    return i18n.getLocale();
}

export function setLocale(locale) {
    i18n.setLocale(locale);
}


// WEBPACK FOOTER //
// ./src/l10n/index.js